import React, { useEffect, useRef, useState } from "react";
import "./style.css";
import { Breadcrumb, DatePickerInput, PopUpModal, Title } from "../../Components/Atoms";
import { getOrderDetails, getShipmentDetails, updateOrderStatus } from "../../APIs";
import { getLocalisedDate } from "../../Library/datetime";
import { LastOrder } from "../../Widgets"
import { Button, Modal, ModalContent, ModalOverlay } from "@chakra-ui/react";
import { CircledCheckIcon, DownloadIcon, LocationIcon } from "../../Assets/images/svgs";
import { ORDER_STATUS, ORDER_STATUS_CANCELLED, SHIPMENT_STATUS_SHIPPED, SHIPMENT_STATUS, ORDER_STATUS_VAL, SELLER_DES, SUBDEALERS_DES, SHIPPING_STATUSES, SHIPMENT_STATUS_CANCELLED, DEVICE_TYPES_VALS, DEV_TYPES, SHIPMENT_STATUSES, SPN_IDS_MAP } from "../../Library/constants";
// import { getLocalisedNumber } from "../../Library/helpers";
import { useLocation, useSearchParams } from "react-router-dom";
import PATHS from "../../Routes/paths"
import config from "../../config";
import { jsonToCSVConvertor } from "../../Library/jsonUtils";
const { crmHostname } = config;

const DESIGNATION = JSON.parse(window.localStorage.getItem("des"));
const orderLabelsAndKeys = [
  { label: "Order ID", key: "orderId" },
  { label: "Quantity", key: "devcnt", formatter: (val) => (val || 0).toLocaleString("en-IN") },
  { label: "Device Type", key: "batTyp", constants: DEV_TYPES },
  { label: "Status", key: "currentState", highlight: true },
  { label: "Order Date", key: "orderTs" },
  // { label: "Amount", key: "transc", nestedKey: "amt", formatter: getLocalisedNumber, symbol: "₹", hide: DESIGNATION !== SELLER_DES },
  { label: "Vendor Name", key: "vendor" },
];

const shipmentLabelsAndKeys = [
  { label: "Shipment ID", key: "orderId" },
  { label: "Quantity", key: "devcnt" },
  { label: "Status", key: "status", highlight: true },
  { label: "Decision Maker", key: "dmNm", isSellerOnly: true },
  { label: "Contact", key: "mob", isSellerOnly: true },
  { label: "Dealer", key: "dnm", isSellerOnly: true },
  { label: "Shipping Address", key: "add", isSellerOnly: true },
];

const OrderDetail = () => {
  const [ orderDetails, setOrderDetails ] = useState({});
  const [ shipmentDetails, setShipmentDetails ] = useState({});
  const [ orderStatus, setOrderStatus ] = useState(0);
  const [ shipmentStatus, setShipmentStatus ] = useState(0);
  const [ showRecievedModal, setShowRecievedModal ] = useState(false);
  const [ selectedReceivingDate, setSelectedReceivingDate ] = useState("");
  const [ receiversName, setReceiversName ] = useState("");
  const [ errorMsg, setErrorMsg ] = useState("");
  const [ showSuccessModal, setShowSuccessModal ] = useState(false);
  const [ showConfirmationModal, setShowConfirmationModal ] = useState(false);

  const [ ordersData, setOrdersData ] = useState({});
  const [ shipmentsData, setShipmentsData ] = useState({});

  const [ searchParams ] = useSearchParams();
  const ORDER_ID = useRef(searchParams.get("idx"));
  const SHIPMENT_ID = useRef(searchParams.get("shipId"));
  const INV_PREFIX = useRef("");
  const location = useLocation();
  const isDashboard = location.pathname.includes(PATHS.DEALERS_OVERVIEW);

  const breadcrumbPaths = [
    { idx: 1, name: (!!SHIPMENT_ID.current) ? "Shipments" : "Orders", link: (!!SHIPMENT_ID.current && DESIGNATION === SELLER_DES) ? PATHS.SHIPMENT_OVERVIEW : (isDashboard ? `${PATHS.DEALERS_OVERVIEW}${PATHS.ORDERS_OVERVIEW}` : PATHS.ORDERS_OVERVIEW) },
    { idx: 3, name: `${!!SHIPMENT_ID.current ? "Shipment" : "Order"} Details - ${SHIPMENT_ID.current || ORDER_ID.current}`, isCurrentPage: true },
  ];

  useEffect(() => {
    if (!!SHIPMENT_ID.current || (DESIGNATION === SUBDEALERS_DES && ORDER_ID.current)) {
      getShipmentDetails(SHIPMENT_ID.current || ORDER_ID.current, null, null, (err, data) => {
        if (err) console.error(err);
        else {
          setShipmentsData(data);
          if (data.prefix) INV_PREFIX.current = data.prefix;
          if (data.orders && data.orders.length) {
            if (data.orders[0].os && data.orders[0].os.length) {
              let statusObj = data.orders[0].os[data.orders[0].os.length - 1];
              data.orders[0].status = SHIPMENT_STATUS[statusObj.stat];
              if (statusObj && statusObj.stat) setShipmentStatus(statusObj.stat);
            }

            setShipmentDetails(data.orders[0]);
          }
        }
      });
    } else {
      getOrderDetails(ORDER_ID.current, null, null, (err, data) => {
        if (err) console.error(err);
        else {
          setOrdersData(data);
          if (data.prefix) INV_PREFIX.current = data.prefix;

          if (!data.orders || !data.orders.length) return console.error(err);
          else data = data.orders[0];

          if (data.os && data.os.length) {
            let statuses = data.os.filter(stat => stat.ts);
            if (statuses.length) {
              let status = statuses[statuses.length - 1].stat;
              data.currentState = ORDER_STATUS[status];
              if (statuses[0].ts) data.orderTs = getLocalisedDate(statuses[0].ts, true);

              data.vendor = "Ajjas";
              setOrderStatus(status);
            }
          }

          setOrderDetails(data);
        }
      });
    }
  }, []);

  const handleMarkReceivedSubmit = () => {
    let errMsg = "";

    if (!receiversName) errMsg = "Please enter receiver's name";
    if (!selectedReceivingDate) errMsg = "Please select receiving date";

    if (errMsg) return setErrorMsg(errMsg);

    let markAsReceivedData = {
      rnm: receiversName,
      rdt: new Date(selectedReceivingDate).getTime(),
      stat: SHIPMENT_STATUS_SHIPPED,
    }

    if (DESIGNATION === SUBDEALERS_DES) markAsReceivedData.shipId = shipmentDetails.orderId;
    updateOrderStatus(markAsReceivedData, (err) => {
      if (err) setErrorMsg(err);
      else {
        setShowSuccessModal(true);

        let newStatus = { stat: SHIPPING_STATUSES["Delivered"], ts: Date.now() };
        setShipmentDetails(prevShipmentDetails => (
          { ...prevShipmentDetails, currentState: "Delivered", os: [ ...prevShipmentDetails.os, newStatus ] }
        ));
        setShipmentStatus(SHIPPING_STATUSES["Delivered"]);
        global.EE.emitEvent(global.EE.EVENT_TYPES.ORDER_STATUS_UPDATED, newStatus);

        setTimeout(() => {
          setShowSuccessModal(false);
          setShowRecievedModal(false);
        }, 2000)
      }
    })
  }

  const getSuccessModalBody = () => {
    return (
      <div className="marked-as-received-modal-msg">
        <CircledCheckIcon />
        <p>Order Marked as Received</p>
      </div>
    )
  }

  const handleOrderCancellation = () => {
    if (!orderDetails.orderId && !shipmentDetails.orderId) return;

    let cancellationDetails = {};
    if (SHIPMENT_ID.current) {
      cancellationDetails.shipId = shipmentDetails.orderId;
      cancellationDetails.stat = SHIPMENT_STATUS_CANCELLED;
    } else {
      cancellationDetails.orderId = orderDetails.orderId;
      cancellationDetails.stat = ORDER_STATUS_CANCELLED;
    }

    updateOrderStatus(cancellationDetails, (err) => {
      if (err) console.error(err);
      else {
        let newStatus;
        if (SHIPMENT_ID.current) {
          newStatus = { stat: SHIPMENT_STATUS_CANCELLED, ts: Date.now() };
          setShipmentDetails(prevShipmentDetails => ({
            ...prevShipmentDetails,
            os: [...prevShipmentDetails.os, newStatus],
            currentState: "Cancelled",
          }));

          setShipmentStatus(SHIPMENT_STATUS_CANCELLED);
        } else {
          newStatus = { stat: ORDER_STATUS_CANCELLED, ts: Date.now() };
          setOrderDetails(prevOrderDetails => ({
            ...prevOrderDetails,
            os: [...prevOrderDetails.os, newStatus],
            currentState: "Cancelled",
          }));

          setOrderStatus(ORDER_STATUS_CANCELLED);
        }

        global.EE.emitEvent(global.EE.EVENT_TYPES.ORDER_STATUS_UPDATED, newStatus);
      }

      setShowConfirmationModal(false);
    });
  }

  const handleInvoiceDownload = () => {
    let pdf = orderDetails.invpdf;
    if (shipmentDetails.invpdf) pdf = shipmentDetails.invpdf;
    if (pdf) {
      var link = document.createElement("a");
      link.href = INV_PREFIX.current + "/" + encodeURIComponent(pdf);
      link.style = "visibility:hidden";
      link.target = "_blank";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }

  const downloadData = (data) => {
    if(!data.length) return;

    var sendToExcel = data.map(obj => Object.assign({}, { imei: obj.imei || "-", imsi: obj.imsi || "-", carrier: obj.spnId ? SPN_IDS_MAP[obj.spnId] : "-" }));

    sendToExcel.forEach((obj, idx) => {
      obj["Sr No"] = idx + 1;
      obj["Imei No"] = obj.imei;
      obj["Imsi No"] = obj.imsi;
      obj["Carrier"] = obj.carrier;
    });

    var sendData = sendToExcel.map(function (exceldata) {
      var args = "Sr No, Imei No, Imsi No, Carrier";
      var filteredData = args.split(",").reduce((mem, arg) => {
        arg = arg.trim();
        mem[arg] = exceldata[arg];
        return mem;
      }, {});
      return filteredData;
    });
    if (sendData.length) jsonToCSVConvertor(sendData, "", true, "IMEIs_" + Date.now(), false);
  }

  const getOrderOrShipmentDetails = (order, shipment) => {
    let isIdxAvailable = (shipment && shipment.orderId) ? shipment.orderId : order.orderId;
    let loopingArray = (shipment && shipment.orderId) ? shipmentLabelsAndKeys : orderLabelsAndKeys;
    let detailObject = (shipment && shipment.orderId) ? shipmentDetails : orderDetails;

    if (isIdxAvailable) {
      return loopingArray.map((detail, idx) => {
        if (detail.isSellerOnly && DESIGNATION === SUBDEALERS_DES) return "";
        let value = detail.nestedKey ? (detailObject[detail.key]?.[detail.nestedKey] || "-") : detailObject[detail.key];
        if (detail.constants && detail.constants[value]) value = detail.constants[value];
        if (!value) return "";

        return (
          <div key={idx} className="keyval-cnt">
            {!detail.hide ? <p className={`order-detail-labels ${(shipment && shipment.orderId) ? "stop-text-wrapping" : ""}`}>
              { detail.label }: <span className={`${detail.class || ""}`} style={{textWrap: "wrap"}}>{ (value !== "-" && detail.formatter) ? `${(value !== "-" && detail.symbol) || ""}${detail.formatter(value)}` : value }</span>
            </p> : null}
          </div>
        )
      });
    }
  }

  return (
    <section className={`panel-main order-details-page ${SHIPMENT_ID.current ? "shipment-details" : ""}`}>
      <header className="order-details-header">
        <Breadcrumb paths={breadcrumbPaths} />
      </header>

      <article className="details-box-container">
        <div className="order-detail-box">
          <Title variant="md" fixed>{(!!SHIPMENT_ID.current || (DESIGNATION === SUBDEALERS_DES)) ? "Shipment Details" : "Order Details"}</Title>
          <div className="single-order-details">
            {getOrderOrShipmentDetails(orderDetails, shipmentDetails)}
          </div>
          {DESIGNATION === SELLER_DES && <div className="dealer-details">
            {orderDetails.dnm ? <p className="order-detail-labels">
              Dealer Name: <span>{orderDetails.dnm}</span>
            </p> : null}
            {/* {orderDetails.add ? <p className="order-detail-labels">
              Dealer Address: <span>{orderDetails.add}</span>
            </p> : null} */}
          </div>}
          { DESIGNATION === SELLER_DES && (orderStatus === ORDER_STATUS_VAL["Placed"] || shipmentStatus === SHIPPING_STATUSES["Shipment Requested"]) ? <Button variant={"outline"} colorScheme="#99F3FF" className="cancel-order-btn" onClick={() => setShowConfirmationModal(true)}>
            Cancel {SHIPMENT_ID.current ? "Shipment" : "Order"}
          </Button> : null}
          { DESIGNATION === SELLER_DES && ((orderDetails && orderDetails.invpdf) || (shipmentDetails && shipmentDetails.invpdf)) && (orderStatus === ORDER_STATUS_VAL["Shipped"] || orderStatus === ORDER_STATUS_VAL["Delivered"] || shipmentStatus === SHIPPING_STATUSES["Shipped"] || shipmentStatus === SHIPPING_STATUSES["Delivered"]) ? <Button variant={"solid"} leftIcon={<DownloadIcon />} className="download-invoice-btn" onClick={handleInvoiceDownload}>
            Invoice
          </Button> : null}

          { DESIGNATION === SUBDEALERS_DES && shipmentStatus === SHIPPING_STATUSES["Shipped"] ? <Button variant={"solid"} className="mark-recieved-btn" onClick={() => setShowRecievedModal(true)}>
            Mark as Recieved
          </Button> : null}
        </div>

        <div className="last-order-widget-container">
          {(ordersData.orders && ordersData.orders.length) || (shipmentsData.orders && shipmentsData.orders.length) ? <LastOrder recentOrderData={ordersData.orders && ordersData.orders.length ? ordersData : null} shipmentData={shipmentsData.orders && shipmentsData.orders.length ? shipmentsData : null} showOrderDetails={false} orderId={SHIPMENT_ID.current || ORDER_ID.current} isShipmentTimeLine={!!SHIPMENT_ID.current || DESIGNATION === SUBDEALERS_DES}/> : null}

          <div className="last-order-widget-buttons">
            {((orderStatus === ORDER_STATUS_VAL["Shipped"] || orderStatus === ORDER_STATUS_VAL["Delivered"] || (shipmentStatus === SHIPPING_STATUSES["Shipped"] || shipmentStatus === SHIPPING_STATUSES["Delivered"])) && ((orderDetails.imeis && orderDetails.imeis.length) || (shipmentDetails.imeis && shipmentDetails.imeis.length))) && <Button variant={"outline"} leftIcon={<DownloadIcon />} colorScheme="#99F3FF" className="device-list-btn download-invoice-btn" onClick={() => downloadData(orderDetails.imeis || shipmentDetails.imeis)}>
              Device List
            </Button>}
            {SHIPMENT_ID.current && shipmentDetails.trkLink ? <Button variant={"outline"} colorScheme="#99F3FF" leftIcon={<LocationIcon />} className="track-order-btn download-invoice-btn" onClick={() => window.open(shipmentDetails.trkLink)}>
              Track Shipment
            </Button> : null}
          </div>
        </div>
      </article>

      { showRecievedModal && <Modal size={"4xl"} isOpen={showRecievedModal} onClose={() => setShowRecievedModal(false)}  isCentered={true}>
          <ModalOverlay />

          <ModalContent className="mark-as-recived-modal" >
            <Title variant="md" fixed>Receiver Details</Title>

            <div className="receiver-form">
              <div className="receiver-name-container">
                <p>Reciever Name</p>
                <input type="text" className="receiver-name-input" onChange={(event) => { setReceiversName(event.target.value); setErrorMsg(""); }} />
              </div>
              <div className="receiving-date-container">
                <p>Recieving Date</p>
                <DatePickerInput
                  value={selectedReceivingDate}
                  onChange={value => { setSelectedReceivingDate(value); setErrorMsg(""); }}
                  inputName={"receiving-date"}
                  className={"receiving-date-input"}
                />
              </div>
            </div>

            <div className="mark-as-received-submit-container">
              <p className="err-msg">{errorMsg}</p>
              <div className="mark-as-received-modal-btns">
                <Button variant={"solid"} className="mark-recieved-cancel-btn" onClick={() => setShowRecievedModal(false)}>
                  Cancel
                </Button>
                <Button variant={"solid"} className="mark-recieved-submit-btn" onClick={handleMarkReceivedSubmit}>
                  Mark as Recieved
                </Button>
              </div>
            </div>
          </ModalContent>
      </Modal> }

      <PopUpModal open={showSuccessModal} modalMsg={getSuccessModalBody()} onModalClose={() => {}} darken />
      <PopUpModal
        open={showConfirmationModal}
        modalMsg={`Are you sure you want to cancel this ${SHIPMENT_ID.current ? "shipment" : "order"} ?`}
        confirmBtn={"Yes"}
        closeBtn={"Cancel"}
        onConfirm={handleOrderCancellation}
        onModalClose={() => setShowConfirmationModal(false)}
        footer={"cancel-order-confirmation"}
      />
    </section>
  )
}

export default OrderDetail
